import GoogleEvent from '../utils/gaEvent';

const useClickEvent = (
  eventName: string,
  eventParams: () => {
    [key: string]: any;
  }
) => {
  return () => {
    const clickEvent = new GoogleEvent(eventName);

    clickEvent.eventParams = eventParams();

    clickEvent.sendEvent();
  };
};

export default useClickEvent;
